import { render, staticRenderFns } from "./Node.vue?vue&type=template&id=b38975d4&scoped=true&"
import script from "./Node.vue?vue&type=script&lang=js&"
export * from "./Node.vue?vue&type=script&lang=js&"
import style0 from "./Node.vue?vue&type=style&index=0&id=b38975d4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38975d4",
  null
  
)

export default component.exports